export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden border-b border-line">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
        {/* 文字主导：上疏 */}
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-mark/30 bg-mark-soft px-3 py-1 text-xs text-mark-text">
            <i className="ri-flashlight-fill text-xs"></i>
            新近曝光 · 每日持续更新
          </span>
          <h1 className="mt-6 font-heading text-3xl font-black leading-tight tracking-tight text-ink md:text-5xl">
            刚被扒出的新瓜，
            <br className="hidden md:block" />
            这里都替你盯住了
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-muted md:text-lg">
            聚焦<span className="text-ink">最近黑料新近曝光</span>与未广泛传播的
            <span className="text-ink">近期流出</span>。不抢热点后的热度，只追仍在发酵的第一手信息，
            并按需求证、逐条对账，给你能信得过的背景梳理。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#track"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-mark px-6 py-3 text-sm font-medium text-cream transition-colors hover:bg-mark-deep"
            >
              <i className="ri-radar-line text-sm"></i>
              查看持续追踪
            </a>
            <a
              href="#topic"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-line bg-card px-6 py-3 text-sm font-medium text-ink transition-colors hover:bg-soft"
            >
              <i className="ri-price-tag-3-line text-sm"></i>
              逛逛话题墙
            </a>
          </div>

          <dl className="mt-8 grid grid-cols-3 gap-3 border-t border-line pt-5">
            {[
              ["2,400+", "累计入库条目"],
              ["36", "正在跟进事件"],
              ["92%", "线索留存率"],
            ].map(([v, k]) => (
              <div key={k}>
                <dt className="font-heading text-xl font-bold text-ink md:text-2xl">{v}</dt>
                <dd className="mt-1 text-xs text-faint">{k}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 配图克制：单张对开 */}
        <div className="relative">
          <div className="relative overflow-hidden rounded-lg border border-line bg-card">
            <div className="relative aspect-[4/3] w-full overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20news%20flat-lay%20on%20warm%20cream%20paper%2C%20stack%20of%20printed%20headline%20sheets%20with%20bold%20black%20chinese%20typography%2C%20one%20sheet%20marked%20with%20a%20red%20ink%20underline%20and%20a%20small%20amber%20tag%2C%20soft%20natural%20light%2C%20minimal%20muted%20warm%20tones%2C%20clean%20editorial%20aesthetic%2C%20no%20blue%20no%20purple%2C%20high%20detail%2C%20overhead%20composition&width=1200&height=900&seq=hero-2026-x1&orientation=landscape"
                alt="最近黑料新近曝光的编辑台纸张特写"
                title="最近黑料 - 新近曝光台面"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"></div>
            </div>
            <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between rounded-md bg-paper/95 px-3 py-2">
              <span className="text-xs text-muted">
                今日头条 · <span className="text-mark-text">正在取证</span>
              </span>
              <span className="text-xs text-faint">图源示意</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}